import styled from "styled-components";
import logout from "../assets/logout.png";
import background_image from "../assets/logout-button.png";

const Logout = styled.button`
  background-image: url(${background_image});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border: 0;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;

  &:before {
    content: "";
    display: block;
    background: url(${logout}) no-repeat;
    width: 25px;
    height: 25px;
    margin: 5px;
    margin-top: 8px;
    float: left;
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
    font-size: 1.75em;
    display: flex;
    align-items: center;
  }
`;

export default Logout;
